module.exports = __webpack_public_path__ + "media/images/payment_methods/directdebit-6895c23f2605a5a2d64ac4789d21a4e3.svg";